import React from "react";

export const LocalisationIcon = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none">
        <path
          d="M15.5 5L11.5 9L7.5 10.5L6 12L13 19L14.5 17.5L16 13.5L20 9.5M9.5 15.5L5 20M15 4.5L20.5 10"
          stroke="#005585"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};
